
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/holidays/holidays",
      function () {
        return require("private-next-pages/holidays/holidays.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/holidays/holidays"])
      });
    }
  